import { Heading, Text } from '@orbita-ui/core';
import styled from 'styled-components';

export const CardHolderSectionHeader = styled.div`
  display: flex;
  flex-wrap: nowrap;
  justify-content: space-between;
`;

export const SectionHeader = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const FormFooter = styled.div`
  display: flex;
  justify-content: end;
`;

export const CardHolderSectionTitle = styled(Heading).attrs({
  bold: true,
  size: 'xl',
})`
  margin-top: 0px;
  margin-bottom: 1rem;
`;

export const CardHolderInfoContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 0.3fr);
  grid-column-gap: 10px;
  grid-row-gap: 10px;
  margin-bottom: 1.6rem;
`;

export const CardHolderEditFormContainer = styled.div`
  grid-template-columns: repeat(3, 0.3fr);
  grid-column-gap: 10px;
  grid-row-gap: 10px;
  margin-bottom: 1.6rem;
`;

export const CardHolderFormSectionTitle = styled.div`
  margin-top: 10px;
  margin-bottom: 1rem;
  font-size: 16px;
  color: rgb(62, 76, 89);
  font-family: Inter, sans-serif;
  font-size: 1.2rem;
  letter-spacing: -0.01em;
  font-weight: 600;
`;

export const CardHolderAdressesContainer = styled.div`
  margin-bottom: 1.6rem;
`;

export const CardHolderAddressInfoContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 0.3fr);
  grid-column-gap: 10px;
  grid-row-gap: 10px;
  margin-bottom: 1.6rem;
`;

export const CardHolderAdressesTitle = styled(Heading).attrs({
  size: 'l',
})`
  text-transform: capitalize;
  margin-bottom: 1rem;
`;

export const CardHolderCardsContainer = styled.div`
  display: flex;
  align-items: center;
`;

export const CardHolderCardsContainerText = styled(Text).attrs({
  color: 'info',
})`
  margin-left: 0.5rem;
`;
